import { tw } from 'uf/tailwindcss-classnames';

export const link = tw('tw-underline', 'tw-text-blue-500');
